import * as React from "react";
import { useState } from "react";
import Dialog from "@mui/material/Dialog";
import login_bottom from "../../assets/profile/login_bottom.png";
import close_icon from "../../assets/profile/close_icon.png";
import toast from "react-hot-toast";
export default function CustomSizeModalBox({ open, handleClose }) {
  const handleDialogClose = () => {
    handleClose();
    setForm({
      name: "",
      email: "",
      phone: "",
    });

    setErrors({});
  };
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
  });
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const collectinput = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    // remove error while typing
    setErrors({ ...errors, [e.target.name]: "" });
  };
  const validateForm = () => {
    let newErrors = {};
    // Name validation
    if (!form.name.trim()) {
      newErrors.name = "Name is required";
    } else if (form.name.trim().length < 3) {
      newErrors.name = "Name must be at least 3 characters";
    }
    // Email validation
    if (!form.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(form.email)) {
      newErrors.email = "Invalid email address";
    }
    // Phone Number validation
    if (!form.phone.trim()) {
      newErrors.phone = "Phone number is required";
    } else if (!/^\d{10}$/.test(form.phone.trim())) {
      newErrors.phone = "Phone number must be 10 digits";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const formsubmit = async (e) => {
    e.preventDefault();
    // stop submit if validation fails
    if (!validateForm()) {
      toast.error("Please complete all required fields before submitting.");
      return;
    }
    try {
      setIsSubmitting(true);
      // const { data } = await axios.post("/contactmail", form);
      // toast.success(data.message);
      toast.success("From Submitted successfully");
      // Reset form
      setForm({
        name: "",
        email: "",
        phone: "",
      });
      setErrors({});
      handleClose();
    } catch (error) {
      toast.error("An error occurred. Please try again later.");
      console.log(error);
    } finally {
      setIsSubmitting(false);
    }
  };
  return (
    <Dialog
      PaperProps={{
        sx: {
          maxWidth: "1040px",
          borderRadius: "0px",
        },
      }}
      open={open}
      onClose={handleDialogClose}
    >
      <div>
        <div className="grid font-lexend md:grid-cols-2 grid-cols-1 w-full  overflow-hidden">
          {/* Left image */}
          <div className="flex flex-col  w-full  relative lg:p-8 p-4 md:p-6 xl:py-10 xl:px-14 md:order-1 order-2">
            <h3 className="xl:text-[26px] lg:text-2xl md:text-xl sm:text-base xs:text-sm text-lg font-semibold leading-[28px]">
              Customize your mattress
            </h3>
            <p className="text-[#6d6d6d] font-light sm:text-xs text-sm xl:pe-8 xl:mt-6 lg:mt-4 mt-2">
              At Moondew, we are committed to transforming your sleep experience
              - one that is custom-created to suit yourpreferences.
            </p>
            <p className="text-[#6d6d6d] font-light sm:text-xs text-sm mt-1 xl:pe-8 ">
              We invite you to choose from a range of variables to create a
              mattress that is well and truly one of a kind:
            </p>

            <div className=" text-[#6d6d6d] sm:text-xs text-sm  mt-1  font-light xl:pe-8">
              <ul className="list-disc xs:ps-4 ps-6">
                <li>&nbsp;Size (length and breadth)</li>
                <li>&nbsp;Thickness </li>
                <li>&nbsp;⁠Construction/layers</li>
                <li>
                  &nbsp;Comfort components (like foam variants with different
                  levels of thickness)
                </li>
                <li>
                  &nbsp;Top fabric and quilting (with varying levels of
                  thickness and design patterns)
                </li>
                <li>
                  &nbsp;Top finish like Euro-Top, Pillow-Top and Waterfall
                </li>
                <li>&nbsp;Single and dual-sided</li>
                <li>&nbsp;Individual sleeper firmness levels</li>
              </ul>
            </div>
          </div>
          {/* Right content */}
          <div className="flex flex-col bg-[#e9f6e8] w-full lg:gap-5 relative sm:gap-2 gap-4 md:gap-4 xl:gap-6 lg:p-8 p-4 md:p-6 xl:py-10 xl:px-14 md:order-2 order-1">
            {isSubmitting && (
              <div className="absolute top-0 left-0 z-10 w-full h-full bg-black opacity-45 " />
            )}

            <button
              onClick={handleDialogClose}
              className="top-4 right-3 absolute"
            >
              <img src={close_icon} alt="" />
            </button>
            <h3 className="xl:text-[20px] lg:text-[18px] sm:pt-4 xs:text-sm text-base sm:leading-[22px] text-[#333333] font-lexend font-normal">
              Get in touch with us today to create a mattress that is created by
              you, for you.
            </h3>
            <form
              onSubmit={formsubmit}
              className=" flex flex-col sm:gap-3 gap-5 rounded-[10px] sm:mt-0 mt-2"
            >
              <div>
                <input
                  placeholder="Name *"
                  type="text"
                  name="name"
                  value={form.name}
                  onChange={collectinput}
                  className={`${errors.name ? "border-red-500" : "border-[#2a552f]"} w-full border bg-transparent font-light   lg:text-lg sm:text-sm text-base xs:h-10 h-[50px]  rounded-[10px] sm:py-1.5 py-3 sm:px-2 px-4  placeholder:font-lexend font-lexend outline-none focus:border-[#2a552f]`}
                />
              </div>
              <div>
                <input
                  placeholder="Email ID *"
                  name="email"
                  value={form.email}
                  onChange={collectinput}
                  type="email"
                  className={`${errors.email ? "border-red-500" : "border-[#2a552f]"} w-full border bg-transparent font-light sm:text-sm  lg:text-lg text-base  xs:h-10  h-[50px]  rounded-[10px] sm:py-1.5 py-3 sm:px-2 px-4  placeholder:font-lexend font-lexend outline-none focus:border-[#2a552f]`}
                />
              </div>
              <div>
                <input
                  placeholder="Phone Number *"
                  name="phone"
                  value={form.phone}
                  onChange={collectinput}
                  type="phone"
                  inputMode="numeric"
                  maxLength={10}
                  className={`${errors.phone ? "border-red-500" : "border-[#2a552f]"} w-full border bg-transparent font-light xs:h-10  sm:text-sm  lg:text-lg text-base h-[50px]  rounded-[10px] sm:py-1.5 py-3 sm:px-2 px-4  placeholder:font-lexend font-lexend outline-none focus:border-[#2a552f]`}
                />
              </div>
              <div className="flex justify-end">
                <button
                  disabled={isSubmitting}
                  className="text-[#f4e390] bg-[#2a552f] text-base font-semibold uppercase lg:text-[22px] font-lexend xs:py-1.5 py-2 lg:py-3 text-center rounded-lg lg:w-[144px] w-28"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
        <img src={login_bottom} alt="" className="w-full" />
      </div>
    </Dialog>
  );
}
